import { type SendApiActionEventParameter } from "../utils/Telemetry";
import type { ApiName, HttpStatusCode } from "../utils/Telemetry/config";

/**
 * Logs an API error by converting it to boolean
 * @param apiName Api to log error for
 * @param error original error that gets parsed and converted
 * @param logicalId Logical Id of the request
 * @param onSendApiAction Callback method from telemetry hook to send telemetry
 */
export function logApiError(
  apiName: ApiName,
  error: Error,
  logicalId: string,
  supportServiceLatency: number,
  onSendApiAction: (params: SendApiActionEventParameter) => void
) {
  onSendApiAction({
    apiName,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    status: (error as any)?.response?.status as HttpStatusCode,
    isInit: false,
    isFromCache: false,
    supportServiceLatency,
    traceId:
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      (error as any)?.response?.headers?.get("x-datasource-traceid") ||
      logicalId,
  });
}
